<template>
  <div class="bf-details">
    <benefits-offers
      :listData="listData"
      :filterData="filterData"
      :description="description"
      :tabListData="tabListData"
      @search="handleSearch"
    ></benefits-offers>
  </div>
</template>

<script>
  import benefitsOffers from './benefitsOffers';
  import { mapState } from 'vuex';

  export default {
    name: 'BenefitsOffersDetails',

    components: {
      benefitsOffers,
    },

    computed: {
      ...mapState(['userInfo']),
    },

    created() {
      let title = '';
      let subtitle = '';
      this.moduleName = this.$route.name;
      if (this.moduleName === 'Visaoffers') {
        this.currentName = 1;
        title = 'views-bo-offers';
        subtitle = 'views-bo-all-offers';
      }

      if (this.moduleName === 'Visabenefits') {
        this.currentName = 2;
        title = 'views-bo-benefit';
        subtitle = 'views-bo-all-benefits';
      }
      this.description = {
        title,
        subtitle,
        desc1: 'views-bo-all-benefit-desc1',
        desc2: 'views-bo-all-benefit-desc2',
        desc3: 'views-bo-all-benefit-desc3',
      };
      this.getCategory();
      this.getListByCondition({ kind: this.currentName });
      this.getFilterCondition();
    },

    data() {
      return {
        moduleName: '',
        currentName: '',
        listData: [],
        filterData: {},
        description: {},
        offerTabList: [],
        benefitsTabList: [],
        tabListData: [],
      };
    },

    methods: {
      handleSearch(data) {
        const searchData = { ...data, kind: this.currentName };
        this.getListByCondition(searchData);
      },

      getListByCondition(data) {
        const { userId, sessionId } = this.userInfo;
        const lang = this.$i18n.locale;
        this.$http.common
          .getListByCondition(data, userId, sessionId, lang)
          .then(res => {
            if (res?.state === '11') {
              this.listData = this.setFakeElement(res.payload, 3);
            } else {
              console.error(res);
            }
          })
          .catch(err => {
            console.error(err);
          });
      },

      getFilterCondition() {
        const { userId, sessionId } = this.userInfo;
        this.$http.common
          .getFilterCondition({
            userId,
            sessionId,
            kind: this.currentName,
          })
          .then(res => {
            if (res?.state === '11') {
              this.filterData = res.payload;
            } else {
              console.error(res);
            }
          })
          .catch(err => {
            console.error(err);
          });
      },

      getCategory() {
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          sessionId,
          kind: this.currentName,
          lang: this.$i18n.locale,
        };
        this.$http.common
          .getCategory(data)
          .then(res => {
            if (res?.state === '11') {
              this.tabListData = res.payload;
              if (this.currentName === 1) {
                this.offerTabList = res.payload;
              }
              if (this.currentName === 2) {
                this.benefitsTabList = res.payload;
              }
            } else {
              console.error(res?.note);
            }
          })
          .catch(err => {
            console.error(err);
          });
      },

      // TODO: 后面可以单独抽离出来
      setFakeElement(arr, count = 4) {
        if (arr.length) {
          // 获取到最后一行剩下多少个元素，判断需要往里面添加多少个假元素
          const itemlist = arr;
          const remainItemLength = itemlist.length % count;
          if (remainItemLength) {
            const needPushLength = count - remainItemLength;
            if (needPushLength) {
              // eslint-disable-next-line no-plusplus
              for (let i = 0; i < needPushLength; i++) {
                itemlist.push({ fakeElement: true });
              }
            }
          }
          return itemlist;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  @import './index';
</style>
